import { usePushPromptStore } from '@stores/usePushPromptStore'
import { useEffect } from 'react'

/**
 * Marca o momento de valor que libera o pedido de permissão de push: a aula
 * aberta ou a home com produto. O pedido em si só existe no app nativo.
 */
export function usePushValueMoment(reached: boolean) {
  const reachValueMoment = usePushPromptStore((state) => state.reachValueMoment)

  useEffect(() => {
    if (reached) reachValueMoment()
  }, [reached, reachValueMoment])
}
